import dayjs from 'dayjs';

import { COMMON_REQUEST_DATETIME_FORMAT } from 'constants/date';

/**
 * Normalises a date value to the request datetime format string.
 * Returns null for falsy input; passes through string values unchanged;
 * formats dayjs instances to the standard request datetime format.
 *
 * @param {string|import('dayjs').Dayjs|null} date
 * @returns {string|null}
 */
export const formatConditionDate = date => {
  if (!date) {
    return null;
  }

  return dayjs.isDayjs(date) ? date.format(COMMON_REQUEST_DATETIME_FORMAT) : date;
};
